export default {"src":"/_next/static/media/en-room-names.53a0397b.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};